import type { Slot } from '../production';
import type { Resource } from '../types/resources';

/**
 * ¿Pueden los `slots` (cada uno usable una vez) cubrir todas las `units`?
 * Emparejamiento bipartito (Kuhn): unidades ≤ 7, slots ≤ ~25.
 */
export function canCover(slots: Slot[], units: Resource[]): boolean {
  if (units.length === 0) return true;
  if (units.length > slots.length) return false;
  const slotOwner = new Array<number>(slots.length).fill(-1);

  const tryAssign = (u: number, seen: boolean[]): boolean => {
    const r = units[u] as Resource;
    for (let s = 0; s < slots.length; s++) {
      if (seen[s] || !(slots[s] as Slot).options.includes(r)) continue;
      seen[s] = true;
      const owner = slotOwner[s] as number;
      if (owner === -1 || tryAssign(owner, seen)) {
        slotOwner[s] = u;
        return true;
      }
    }
    return false;
  };

  for (let u = 0; u < units.length; u++) {
    if (!tryAssign(u, new Array<boolean>(slots.length).fill(false))) return false;
  }
  return true;
}
